import { apiClient, type SiteWithAreaEntity } from '@/libs/api'
import { type SiteType } from '@/libs/api/types'

export const fetchSitesWithArea = async (
  query: {
    tenantKey: string
    dcId?: number
    tourId?: number
    shippingDate?: string
    siteType?: SiteType
    customerId?: number
    areaId?: number | null
  },
  signal?: AbortSignal
): Promise<SiteWithAreaEntity[]> => {
  const {
    tenantKey,
    dcId,
    tourId,
    shippingDate,
    siteType,
    customerId,
    areaId
  } = query
  const { data } = await apiClient._tenant(tenantKey).sites.with_area.$get({
    query: {
      ...(dcId && { dcId }),
      ...(tourId && { tourId }),
      ...(shippingDate ? { shippingDate } : {}),
      ...(siteType ? { siteType } : {}),
      ...(customerId ? { customerId } : {}),
      ...(areaId ? { areaId } : {})
    },
    config: {
      signal
    }
  })
  return data
}
